var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ml-1",attrs:{"icon":"","height":28,"width":28},on:{"click":_vm.showAttributeEditForm}},[_c('v-icon',{attrs:{"title":"Redaguoti","size":"20"}},[_vm._v("mdi-pencil")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }